<script setup lang="ts">
import { computed } from 'vue';
import BaseModal from '../ui/BaseModal.vue';
import BaseButton from '../ui/BaseButton.vue';
import MoreOptionsModal from '../shared/MoreOptionsModal.vue';
import { useModalStore, ModalType } from '@/stores/modal.ts';
import FilterList from '@/components/productList/FilterList.vue';
import { $t } from '@/composables/translations/useTranslate.ts';

const modalStore = useModalStore();

const isFiltersModalOpen = computed({
  get: () => modalStore.isModalOpen(ModalType.FILTERS),
  set: (value: boolean) => {
    if (!value) {
      handleFilterClose();
    }
  },
});

const handleFilterClose = () => {
  modalStore.closeModal(ModalType.FILTERS);
};
</script>

<template>
  <!-- More Options Modal -->
  <MoreOptionsModal />

  <!-- Filters modal -->
  <BaseModal
    v-model:open="isFiltersModalOpen"
    :title="$t('ibe.filters.filter', 'Filter')"
    variant="sidebar"
    position="left"
    size="md"
    no-padding
  >
    <FilterList />

    <template #footer>
      <div class="flex gap-4">
        <BaseButton class="flex-1" @click="handleFilterClose">
          {{ $t('ibe.common.apply', 'Apply') }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>
